import { Box, IconButton, Typography, TypographyProps } from "@mui/material";
import React from "react";
import { useStyles } from "./Title.styles";
import { useModal } from "src/Shared/Hooks";
import WarningPopup from "../WarningPopup/WarningPopup";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";
import { alignProperty } from "@mui/material/styles/cssUtils";

type Props = {
  title: string;
  backButtonEnabled?: boolean;
  warningRequired?: boolean;
  variant?: TypographyProps["variant"];
};
const Title: React.FC<Props> = ({
  title,
  warningRequired,
  backButtonEnabled,
  variant = "h6"
}) => {
  const classes = useStyles();
  const modal = useModal();
  const navigate = useNavigate();

  const onConfirm = (e: boolean) => {
    if (e) {
      navigate(-1);
    }
  };

  const handleClick = () => {
    if (warningRequired) {
      modal.open(
        <WarningPopup
          onConfirm={onConfirm}
          message="Are you sure you want to leave. Leaving the page will result in lost
            data?"
        />
      );
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "baseline" }}>
        {backButtonEnabled && (
          <IconButton color="secondary" onClick={handleClick}>
            <ArrowBackIcon />
          </IconButton>
        )}

        <Typography className={classes.title} variant={variant} gutterBottom>
          {title}
        </Typography>
      </Box>
    </>
  );
};

Title.defaultProps = {
  backButtonEnabled: true,
  warningRequired: false,
};
export default Title;
